/* tslint:disable:max-line-length */
import {UntilDestroy} from '@ngneat/until-destroy';
import {EventEmitter, Injectable} from '@angular/core';
import {StepperService} from '@mydocma/import-export';
import {CellValidationResult} from '../common/cell-validate-import.result';

@UntilDestroy()
@Injectable()
export class FaultsImportStepperService {

  public isLoading = false;
  public stepperService: StepperService;

  public selectedFile: {
    ImportFile: File | null,
    Files: string[],
    ZipFile: File | null,
    IsPreValidationValid?: boolean,
    ValidationResult?: {[fieldName: string]: CellValidationResult}[],
    ValidationData?: {[fieldName: string]: CellValidationResult}[],
    PreviewData?: {[fieldName: string]: CellValidationResult}[]
  };

  public selectedFileDeleted: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

}
